import { jsonToQueryString } from "../shared/utils";
import ApiBase from "./base";

export const _ADMIN_URL = "admin";

export async function getAdminList(params) {
    const response = await ApiBase.get(`${_ADMIN_URL}?${jsonToQueryString(params)}`);

    return response;
}

